export default ['JsonRPCService', (JsonRPCService) => {
    return {
        generateUploadToken: (xCenter, service) => {
            return JsonRPCService.send(xCenter, service, 'generateUploadToken', []);
        }
    };
}];
